import { render, staticRenderFns } from "./UiHorizontalCarousel.vue?vue&type=template&id=0d52fde0&scoped=true&"
import script from "./UiHorizontalCarousel.vue?vue&type=script&lang=js&"
export * from "./UiHorizontalCarousel.vue?vue&type=script&lang=js&"
import style0 from "./UiHorizontalCarousel.vue?vue&type=style&index=0&id=0d52fde0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d52fde0",
  null
  
)

export default component.exports